import React, { useEffect, useState } from 'react'
import './style.scss'
import Modal from '../../components/common/modal/Modal'
import SinglePage from '../../components/common/page/SinglePage'
import SpinWithMessage from '../../components/common/spinners/SpinWithMessage'
import { BsDatabaseFillX } from 'react-icons/bs'
import { accountingAxios } from '../../config/axios'
import toast from 'react-hot-toast'
import TableFilter from '../../components/common/table-filter/TableFilter'
import { useNavigate } from 'react-router-dom'


const SalesBillsList = () => {
    const [modal, setModal] = useState({ status: false })
    const [data, setData] = useState([])
    const [loading, setLoading] = useState('fetch')
    const navigate = useNavigate()


    useEffect(() => {

        accountingAxios.get('/sales/bills/pending').then((response) => {
            setData(response.data)
            setLoading('')
        }).catch((error) => {
            toast.error(error.message)
            setLoading('')
        })
    }, [])

    return (
        <div className="sales-bills-list-div">
            <Modal modal={modal} setModal={setModal} />
            <SinglePage titleArray={['Sales Bill Requests']}>
                {data[0] ? <TableFilter srlNo={true} >
                    <table>
                        <thead>
                            <tr>
                                <th>Prospect ID</th>
                                <th>Name</th>
                                <th>Sales man</th>
                                <th>Install Assign</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((prospect, index) => (
                                <tr key={index} >
                                    <td onClick={() => navigate(`/sales/item/${prospect?.prospect_id}/view`)}>{prospect?.prospect_id}</td>
                                    <td onClick={() => navigate(`/sales/item/${prospect?.prospect_id}/view`)}>{prospect?.first_name} {prospect?.last_name}
                                        <br></br>
                                        {prospect?.address?.address}, {prospect?.address?.place}, {prospect?.address?.city}
                                    </td>
                                    <td onClick={() => navigate(`/sales/item/${prospect?.prospect_id}/view`)}>{prospect?.sales_man}</td>
                                    <td onClick={() => navigate(`/sales/item/${prospect?.prospect_id}/view`)}>{new Date(prospect?.i_schedule_date || prospect?.salesman_assign_i_date).toDateString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </TableFilter>
                    : <SpinWithMessage icon={!loading && <BsDatabaseFillX />} message={loading ? 'Fetch data...' : 'No data'} spin={loading} />
                }
            </SinglePage>
        </div>
    )
}

export default SalesBillsList